import { instance } from "api/apiBase";
import {
  AiSettings,
  RecommendationSummary,
  RecommendationSummaryFeedback
} from "./types";

/**
 * AI recommendation summary API (BSCPF-6408).
 *
 * The summary itself is not fetched here: boompay-api merges it into the
 * application detail payload (`application.recommendation_summary`), so the
 * card reads it from the `["APPLICATION", id]` query.
 */
export const submitRecommendationSummaryFeedback = async (
  applicationId: number,
  summaryId: number,
  feedback: RecommendationSummaryFeedback
): Promise<RecommendationSummary> =>
  (
    await instance.post<RecommendationSummary>(
      `/portal/v1/applications/${applicationId}/summary_feedback/${summaryId}`,
      { feedback }
    )
  ).data;

export const updateAiSettings = async (
  settings: Partial<AiSettings>
): Promise<AiSettings> =>
  (
    await instance.patch<{ ai_settings: AiSettings }>(
      `/portal/v1/users/ai_settings`,
      { ai_settings: settings }
    )
  ).data.ai_settings;
